import { FC, useState } from 'react';
import ErrorBoundary from '../../../components/error-boundaries';
import { getAssetsUrl } from 'utils/urlUtils';
import Button from 'modules/shared-components/button/button';

interface Props {
  showNumber: number;
  exchanges: { exchangeId: number; name: string; key: string }[];
}

const ExchangesExpandableList: FC<Props> = ({ showNumber, exchanges }) => {
  const [compressed, setCompressed] = useState(true);

  function drawExchangeList() {
    const exchangesList = exchanges
      ?.slice(0, !compressed ? exchanges?.length : showNumber)
      ?.map(
        (exchange) =>
          exchange && (
            <div
              className=" mr-1 my-1 py-1 inline-flex items-center xxs:px-2 bg-white-50 dark:bg-black-600 shadow-sm"
              key={'exchange_' + exchange?.key}
            >
              <img
                onError={(e: any) => {
                  e.target.onerror = null;
                  e.target.src = require('assets/img/cryptocurrencies/icons/generic.png');
                }}
                src={
                  getAssetsUrl() +
                  '/static/img/exchanges/' +
                  exchange?.key.toLowerCase() +
                  '.svg'
                }
                style={{ width: '30px' }}
                className="px-1"
                alt="exchange logo"
              />{' '}
              <span className="pr-1 text-white-800 dark:text-white-200">
                {exchange?.name}
              </span>
            </div>
          )
      );

    if (exchanges?.length > showNumber) {
      return (
        <div key="expand_button">
          <Button
            className="py-1 my-1 mr-1 px-1 text-white-800 dark:text-white-200  xxs:px-2 bg-white-50 dark:bg-black-600  cursor-pointer float-left border-none"
            onClick={() => setCompressed(!compressed)}
          >
            {compressed ? (
              <span>+{exchanges?.length - showNumber}</span>
            ) : (
              <span>-</span>
            )}
          </Button>
          {exchangesList}
        </div>
      );
    } else {
      return exchangesList;
    }
  }

  return <ErrorBoundary>{drawExchangeList()}</ErrorBoundary>;
};

export default ExchangesExpandableList;
